import { Injectable } from '@angular/core';
import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';

@Injectable()
export class ReportGeneratorsService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {
    }

    generateSettlementReport(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.generateCSV.api;
        return this.requestService.post(url, payload);
    }

    downloadSettlementReportById(id: string) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.generateCSVbyId.api + '/' + id;
        return this.requestService.get(url).map(_ => _.data);
    }

    generateTransactionReport(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.sales.generateCSV.api;
        return this.requestService.post(url, payload).map(_ => _.data);
    }

    generateTransactionReturnReport(payload) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.sales.generateReturnCSV.api;
        return this.requestService.post(url, payload).map(_ => _.data);
    }

    download(bucket: string, file: string) {
        let url = this.configService.getSphinxUrl('sahara', bucket, file);
        return this.requestService.get(url, {attachment: true}, 'blob');
    }
}




// WEBPACK FOOTER //
// ./src/app/core/services/report-generators.service.ts